export default __webpack_public_path__ + "static/media/920.f2c40ab9.png";